import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {FmlxModal} from 'fmlx-common-ui';
import {FMLX_BUTTON} from '../../const/FmlxComponentEnum';
import {useHistory} from 'react-router-dom';
import './ExitModal.scss';

const ExitModal = ({hasUnsavedChanges, modalTitle, message, onClose, onConfirm}) => {
  const history = useHistory();
  const [state, setState] = useState({
    path: '',
    triggerExit: false,
    isModalOpen: false,
  })

  useEffect(() => {
    if (state.triggerExit) {
      history.push(state.path);
    }

    const unblock = history.block((location) => {
      if (hasUnsavedChanges) {
        setState((s) => ({...s, path: location.pathname, isModalOpen: true}))
        return false;
      }
      return true;
    });

    return () => {
      unblock();
    }
  }, [history, hasUnsavedChanges, state.triggerExit, state.path])

  const onConfirmHandler = () => {
    setState((s) => ({...s, isModalOpen: false, triggerExit: true}));
    if (onConfirm) {
      onConfirm();
    }
  }

  const onCloseHandler = () => {
    setState((s) => ({...s, isModalOpen: false}));
    if (onClose) {
      onClose();
    }
  }

  return (
    <FmlxModal
      title={modalTitle}
      open={state.isModalOpen}
      onCloseClick={onCloseHandler}
      primaryButton={{
        show: true,
        disabled: false,
        label: 'Confirm',
        type: FMLX_BUTTON.TYPE.PRIMARY,
        variant: FMLX_BUTTON.VARIANT.CONTAIN,
        onClick: onConfirmHandler
      }}
      secondaryButton={{
        show: true,
        disabled: false,
        label: 'Close',
        type: FMLX_BUTTON.TYPE.BASIC,
        variant: FMLX_BUTTON.VARIANT.OUTLINE,
        onClick: onCloseHandler,
      }}
      tertiaryButton={{
        show: false,
      }}
    >
      <div className='exit-modal-content'>
        {message}
      </div>
    </FmlxModal>
  );
};

ExitModal.propTypes = {
  hasUnsavedChanges: PropTypes.bool,
  modalTitle: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

ExitModal.defaultProps = {
  hasUnsavedChanges: false,
  modalTitle: 'Exit Confirmation',
  message: 'Are you sure you want to leave? You have unsaved changes',
  onClose: null,
  onConfirm: null,
};

export default ExitModal;
